module.exports = {
  UNIVERSITY_TYPES: {
    1: { th: 'ทปอ.' },
    2: { th: 'มรภ.' },
    3: { th: 'มทร.' },
    4: { th: 'เอกชน' },
    5: { th: 'สมทบ' },
  },
};
